import React from 'react';
import Table from '../../../common/PDF/Table';
import { splitByThousands, addPercent } from '../../../../helpers/NumberFormatter';

export default ({data})=>{
	const row = data[0];
	const columnWidth = Math.floor(100/Object.values(row).length);
	let columns = [];
	
	for(let key of Object.keys(row)) {
		columns.push({
			key, 
			title: key, 
			width: columnWidth, 
			fontSize: 5,
			formatFn: key == 'period' ? undefined : splitByThousands	
		})
	}
	
	return <Table
		columns={columns}
		items={data}
	/>
}